module.exports = __webpack_public_path__ + "static/media/qrcode.29f6fd1f.svg";